import { BaseEntity } from "@mp/common/entities/base.entity";
import { TeamModel } from "@m481/mp-sdk-ng";

export interface TeamEntity extends BaseEntity {
    name: string;
    timeZone: string;
    managersIds: Array<string>; //not in model
    usersIds: Array<string>; //not in model
}

export class TeamEntityHelper {
    public static fromModel(teamModel: TeamModel): TeamEntity {
        return {
            id: teamModel.id,
            name: teamModel.name,
            timeZone: teamModel.timeZone,
            managersIds: [],
            usersIds: [],
            isEnabled: teamModel?.isEnabled ?? true
        };
    }

    public static toModel(teamEntity: TeamEntity): TeamModel {
        return {
            id: teamEntity.id,
            name: teamEntity.name,
            slug: "",
            timeZone: teamEntity.timeZone,
            isEnabled: teamEntity?.isEnabled ?? true
        };
    }
}
